import { ColumnType } from "antd/es/table"
import { IProjectDataRank } from "../types/projectDataRanks.types"
import moment from "moment-timezone"
import { useMemo } from "react"
import { Space } from "antd"
import { AmazonDataState } from "../../../types/project"
import NotAvailableTag from "../../../ui/NotAvailableTag"
import NotAvailableTagKeyword from "../../../ui/NotAvailableTagKeyword"

const useProjectDataColumns = (
  keywordsCount: number,
  startDate: string,
  endDate: string
): ColumnType<IProjectDataRank>[] => {
  const columns: ColumnType<IProjectDataRank>[] = [
    {
      title: `Keywords (${keywordsCount})`,
      dataIndex: "keywordText",
      key: "keywordText",
      render: (keywordText: string, record: IProjectDataRank) => {
        return (
          <Space>
            {keywordText}
            <NotAvailableTagKeyword state={record.state} />
          </Space>
        )
      },
    },
    { title: "Sponsored rank", dataIndex: "sponsoredRank", key: "sponsoredRank" },
    { title: "KW Clicks", dataIndex: "clicks", key: "clicks" },
    { title: "KW Sales", dataIndex: "sales", key: "sales" },
    {
      title: "KW Conv",
      dataIndex: "conversion",
      key: "conv",
      render: (conversion: number) => (conversion ? conversion.toFixed(2) + "%" : 0),
    },
  ]

  const dates = useMemo(() => buildDateArray(startDate, endDate), [startDate, endDate])
  columns.push(
    ...dates.map((date) => ({
      title: date.tableHeaderDate,
      key: date.tableHeaderDate,
      render: (record) => {
        const rank = record.organicRank[date.filterDate]
        return rank || rank === 0 ? rank : "-"
      },
      width: "100px",
    }))
  )

  const memoColumns = useMemo(() => columns, [columns])
  return memoColumns
}

interface IDate {
  tableHeaderDate: string
  filterDate: string
}

function buildDateArray(startISO: string, endISO: string): IDate[] {
  const start = new Date(startISO)
  const end = new Date(endISO)

  const fmt = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
  })

  const result: IDate[] = []
  for (let d = new Date(end); d >= start; d.setDate(d.getDate() - 1)) {
    result.push({
      tableHeaderDate: fmt.format(d).toUpperCase(),
      filterDate: moment(d).format("YYYY-MM-DD"),
    })
  }

  return result
}

export default useProjectDataColumns
